import { render } from "./ProjectActivityReport.vue?vue&type=template&id=1b3435c7&scoped=true"
import script from "./ProjectActivityReport.vue?vue&type=script&lang=js"
export * from "./ProjectActivityReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=1b3435c7&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3435c7"]])

export default __exports__